<template>
    <!-- 专题服务 -->
    <div class="home-region subject">
        <div class="region-cont">
            <div class="tit tit-blue">专题服务 <div class="tit-bottom"></div></div>
            <div class="subject-list">
                <div class="list-cont" v-for="(item,index) in subjectList" :key="index">
                    <div class="cont-pic">
                        <img width="100%" height="100%" :src="item.pic" alt="">
                        <p class="cont-tit">{{item.tit}}</p>
                    </div>
                    <div class="cont-txt">
                        <ul>
                            <li :class="index==0?'pl20':''" class="txt" v-for="(list,num) in item.list" :key="num">
                                <span class="icon"></span>{{list.val}}
                            </li>
                        </ul> 
                        <p class="to-details">点击进入<i class="el-icon-arrow-right"></i></p>
                    </div>
                </div>
            </div> 
        </div>
            
    </div>
</template>

<script>
import homeData from '../homeData.js';

export default {
    data () {
        return {
            subjectList:homeData.subjectList,
        }
    }
}
</script>

<style lang="less" scoped>
//专题服务
.subject{ 
    // height: 600px; 
    // background: url('../../../assets/images/home/subject.jpg') no-repeat center;
    // background-size: cover;
    background: linear-gradient( 180deg, rgba(229,244,255,0) 0%, rgba(229,243,255,0.94) 40%, #E5F3FF 100%);
    .subject-list{
        width: 1200px;
        padding:20px;
        background: #fff;
        display: flex;
        justify-content: space-between;
        .list-cont{
            width: 560px;
            display: flex;
            .cont-pic{
                position: relative;
                width: 340px;
                height: 260px;
                .cont-tit{
                    position: absolute;
                    top:0;
                    left: 0;
                    width: 200px;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    background: linear-gradient( 90deg, #806041 0%, #957C65 100%);
                    border-radius: 0px 0px 8px 0px;
                    font-weight: 500;
                    font-size: 16px;
                    color: #F6EFE7;
                }
            }
            .cont-txt{
                width: 222px; 
                background: #F6EFE7;
                border: 2px solid #CBBBAD;
                border-left: none;
                padding-top:30px;
                text-align: center;
                ul{
                    width: 174px;
                    margin: 0 auto;
                    height: 190px;
                }
                .txt{ 
                    height: 22px; 
                    font-weight: 500;
                    font-size: 16px;
                    color: #666666;
                    line-height: 22px; 
                    margin-bottom: 14px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    .icon{
                        width: 8px;
                        height: 8px;
                        background: url('../../../assets/images/home/subject-icon.png') no-repeat left;
                        background-size:contain ;
                        margin-right: 6px;
                    }
                }
                .to-details{
                    cursor: pointer;
                    padding-right: 32px;
                    text-align: right;
                    font-weight: 500;
                    font-size: 14px;
                    color: #926641;
                    line-height: 20px;
                    ::v-deep .el-icon-arrow-right:before{
                        font-weight: bold;
                    }
                }
            }
        }
    }
    .pl20{
        padding-left: 20px;
    }
}
</style>